// Project Configuration
// In production, these values can be replaced with environment variables

export const PROJECT_CONFIG = {
  name: process.env.REACT_APP_PROJECT_NAME || 'APEX',
  fullName: process.env.REACT_APP_PROJECT_FULL_NAME || 'Advanced Panel EXpert System',
  description: process.env.REACT_APP_PROJECT_DESCRIPTION || 'Scientific Review Panel Management Platform',
  shortName: process.env.REACT_APP_PROJECT_SHORT_NAME || 'APEX',
};

export default PROJECT_CONFIG;

